import produce from 'immer';
import { PAGE_IN_POPUP_DATA_SET, PAGE_IN_POPUP_STATE_CLEAR } from './actions';

export const defaultState = {
    url: {},
    path: ''
};

export const reducer = produce((draftState, action) => {
    switch (action.type) {
        case PAGE_IN_POPUP_DATA_SET: {
            Object.assign(draftState, {
                ...action.payload
            });

            break;
        }

        case PAGE_IN_POPUP_STATE_CLEAR: {
            Object.assign(draftState, defaultState);

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
